require('shouyou/widgets/mobileModVideo')

var pingjs = require('widgets/ping')
  , detector = require('widgets/detector')

var $ = require('jquery')
  , doc = $(document)
  , win = $(window)
  , body = $('body')

function navFixed(){
  var y = win.scrollTop(),
    h_header = $('.header').height();

  if(y > h_header){
    $('.btn-gotop').fadeIn();
  }else{
    $('.btn-gotop').fadeOut();
  }
}

$(function() {
  doc.on('click', 'a[href="#"]', function(e) {
    e.preventDefault()
  })

  $('.btn-gotop').click(function(){
    $(document).scrollTop(0);
  });

  win.scroll(function(){
    navFixed();
  });
  navFixed();

  var weixinOverlayTip =
    $('<div>', { 'class': 'pop-yd weixin-overlay-tip'})
      .css({
        position: 'fixed'
      , top: '0'
      , left: '0'
      , width: win.width()
      , height: win.height()
      , zIndex: '9999'
      , background: 'rgba(0,0,0,0.6) url(//ue.17173cdn.com/a/newgame/index/2016/v2.8.4/m/img/yd.png) no-repeat right 10%'
      , 'background-size': '60% auto'
      })

  weixinOverlayTip.click(function() {
    weixinOverlayTip.detach()
  })

  doc.on('touchstart', '.weixin-overlay-tip', function(e) {
    var el = $(e.currentTarget)
    el.remove()
  })

  doc.on('show:weixin-overlay', function() {
    if (!detector.isWexinQQBrowser()) { return }

    body.append(weixinOverlayTip)
  })

  doc.on('touchstart', '.ng-channel-bt-dl', function(e) {
    var el = $(e.currentTarget)

    if (el.hasClass('disabled')) { return }

    pingjs.trackEvent(
        el.hasClass('is-ios')
      ? 'MOBILE_GAME_DOWNLOADED_IN_IOS'
      : 'MOBILE_GAME_DOWNLOADED_IN_ANDROID'
    , window.location.href
    )
  })

  doc.on('click', '.ng-channel-bt-dl', function(e) {
    var el = $(e.currentTarget)

    if (el.hasClass('disabled') || !detector.isWexinQQBrowser() || detector.isiOS) { return }

    e.preventDefault()

    doc.trigger('show:weixin-overlay')
  })

  doc.on('click', '.ng-engage-by-app', function(e) {
    // var newGameCode = ued.newgameCodes.Android || ued.newgameCodes.PC
    if (detector.isWexinQQBrowser()) {
      doc.trigger('show:weixin-overlay')
    }
    else {
      // detector.checkOpen(function (opend) {
      //   if (!opend) {
      //     var youliUrlParams
      //     , uid = Passport.data('uid')
      //     , ssid = ued.pingjs.get('ssid')
      //     , youliUrlParams = 'page=info&actionType=follow&code='+newGameCode+''
      //     if ( uid ) {
      //       youliUrlParams = youliUrlParams+'&user='+uid+''
      //     }
      //     location.href = 'https://youli.17173.com/app/download.shtml?utm_source=173yl&utm_medium=newgame&'+youliUrlParams+'&ssid='+ued.pingjs.get('ssid')+''
      //   }
      // });
      // location.href = 'yl://youli?page=info&actionType=follow&newGameCode='+newGameCode+'';
      location.href = '//news.17173.com/hao/app/download.shtml?channel=newgame';
    }
    e.preventDefault();
  })
})
